<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

    <!-- Navigation -->
    <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a class="nav-link marketplace" routerLink="/how-it-works" style="cursor: pointer;">How it works</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="javascript:;" (click)="goToMarketplace()" style="cursor: pointer;">Marketplace</a>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="javascript:;" routerLink="/pricing">Pricing</a>
        </li>
        <li class="nav-item dropdown col-1-dropdown">
          <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
          <div class="dropdown-menu" style="width: 200px;">
            <ul>
              <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g id="Icons/Navigation/Arrow Down/Black">
                    <g id="Group">
                      <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                  </g>
                </svg> -->
              </li>
              <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
              <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
            </ul>
          </div>
        </li>
        <li class="nav-item">
          <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
        </li>
         <li class="nav-item signup-btn">
        <!-- <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login" data-target="#signup-popup">Sign up for Free</a> -->
        </li>
        <li class="nav-item login-btn">
        <a class="nav-link btn" href="profile.html" data-toggle="modal" (click)="loginLogout()" data-target="#loginmodal">{{currentValue}}</a>
        </li>
      </ul>
      </div>
    </div>
    </nav>
</header>

<section>
  <div  class="bill-wrapper">
		<!-- <div class="bill-brand">
			<img src="https://crafttor.com/assets/img/logo.svg">
		</div> -->
		<div class="bill-content">
			<div class="bol-top-bar"><img src="assets/img/banner-logo.png"></div>
			<div class="bill-left">
				<div class="bill-desc">
					<h2>Plan Freatures</h2>
					<ul class="tick-list">
						<li>20 members</li>
						<li>5TB Space</li>
						<li>5TB Space</li>
						<li>20 members</li>
						<li>5TB Space</li>
						<li>5TB Space</li>
					</ul>
				</div>
			</div>
			<div class="bill-right">
				<div class="plan-inner">
					<table border="0" cellpadding="0" cellspacing="0" width="100%;">
						<tr>
							<th width="65%">Plan Summary</th> <th width="35%">Total</th>
						</tr>
						<tr>
							<td>Enterprise <span>Annual Plan</span> </td>
							<td valign="top">$920<sub>/-</sub></td>
						</tr>
						<tr>
							<td colspan="2"><a class="button" href="javascript:;">Pay $920/-</a> </td>
						</tr>
					</table>
				</div>
			</div>
			<div class="bill-bottom">
				<h2>Contact Us:</h2>
				<a href="mailto:Info@crafttor.com" class="mail"><i aria-hidden="true" class="fa fa-envelope"></i> Info@crafttor.com</a>
				<a href="tel:+91-9971891479" class="phone"><i aria-hidden="true" class="fa fa-phone"></i> +91-9971891479</a>
				<h2>Terms & Conditions</h2>
				<p>For medium to large teams with 20+ members get a chance to pick one of new This International Women’s Day, celebrate & cherish the ones dear to you. Show your appreciation for them using design.</p>
			</div>
		</div>
	</div>
</section>

<!--
<section class="price-power-section">
<div class="container">
<div class="panel-wrapper">
<div class="left-panel">
  <div class="box-wrapper mb-4">
    <div class="d-flex">
      <div class="img-wrpper">
        <img src="assets/img/payment.png">
      </div>
      <div class="content-wrapper">
        <h3 class="mb-0 pb-0">Ready for Crafttor?</h3>
        <p>Upgrade your plan and get:</p>
        <ul>
          <li><strong>Unlimited</strong> user billed at $/user</li>
          <li><strong>Unlimited</strong> boards</li>
          <li><strong> GB</strong> of storage & <strong></strong> invites.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
<div class="right-panel">
  <div class="box-wrapper">
    <div class="plane-summary">
      <h3>Plan summary</h3>
      <table>
        <tbody>
              <tr>
                <td>
                  <input type="radio" name="subscription" value="yearly" id="yearly" checked="">
                  <label for="yearly">Yearly
                    <div class="badge">Save 20%</div>
                  </label>
                </td>
                <td>
                  <div class="price">$20/month</div>
                </td>
              </tr>
            <tr>
              <td colspan="2" class="coupon-box">
              <div class="collapse multi-collapse" id="multiCollapseExample1">
                <div class="input-group">
                <input type="text" class="form-control coupon" name="" placeholder="Coupon code">
                  <span class="input-group-append">
                    <button class="btn btn-primary btn-apply coupon">Apply</button>
                  </span>
                </div>
              </div>
              </td>
            </tr>
          <tr class="user">
            <td><p>1 user on annual plan</p></td>
            <td>
              <p class="small">$240</p>
            </td>
          </tr>

          <tr class="total">
            <td><p>Total</p></td>
            <td>
              <div class="price">$240</div>
            </td>
          </tr>
          <tr class="button-wrapper">
            <td colspan="2">
              <a class="button" href="javascript:;" (click)="openLogin('240', 'usd', '4')">Upgrade</a>
            </td>
          </tr>
          <tr>
            <td colspan="2">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
</div>
</div>
</section> -->

<!-- Footer -->
<!-- <footer class="site-footer">
	<div class="container">
	<div class="row">
		<div class="col-sm-4">
			<div class="coulmn-1">
				<img src="assets/img/logo.svg">
				<p>Free assests for your next project</p>
				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
			</div>
		</div>
		<div class="col-sm-5">
			<ul class="menu">
				<li><a routerLink="/terms">Term & Conditions</a></li>
        <li><a routerLink="/contact">Contact Us</a></li>
			</ul>
		</div>
		<div class="col-sm-3">
			<ul class="social-icons">
				<li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank” alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
				<li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
				<li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
				<li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
				<li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
			</ul>
		</div>
		<div class="col-sm-12 text-center">
			<small>copyright © 2025 Crafttor. All rights reserved</small>
		</div>
	</div>
	</div>
</footer> -->

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':loginStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="margin-top:200px; height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<button style="text-align: end;" type="button" class="close" (click)="closeLoginDialog()" data-dismiss="modal" aria-label="Close">
				<img src="assets/img/cross.svg" alt="download free illustrations">
			</button>
			<div class="modal-body">
				<h3 style="margin-bottom:0px;">Login to continue</h3>
				<p style="margin-bottom:30px; margin-top:8px;">Please login to create workspace</p>
				<div class="button-wrapper">
					<a href="javascript:;" class="button google-login-btn" (click)="signInWithGoogle()"><i class="fa fa-google-plus"></i> Continue with Google</a>
				</div>
			</div>

		</div>
	</div>
</div>
